export const CoverageAreas = ["Monday-Thursday (Johr Town, Abdalian Town and Tech Society)", 
"Tuesday-Friday (Wapda Town, Valancia Town, Neshaman-i- Iqbal, Air Line Housing Society)",
"Wednesday – Saturday (Architect Society, Alhamra Town, PCSIR, Expo Town, Judicial Colony, Sunny Park, Nawab Town, Ali Town, Achitison Society, Shabbir Town and Punjab University Town)",
];